const config = require('./config.json')

const env = process.env.NODE_ENV
const conf = config[env]

export {
  conf
}